import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-rst",
  "use": "icon-rst-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-rst\"><path fill=\"#333333\" d=\"M19.456 436.224h988.16v148.48H19.456V436.224z m0-289.792h988.16v148.48H19.456V146.432z m70.656 584.704c40.96 0 73.728 32.768 73.728 73.728s-32.768 73.728-73.728 73.728-73.728-32.768-73.728-73.728 32.768-73.728 73.728-73.728z m265.216 0c40.96 0 73.728 32.768 73.728 73.728s-32.768 73.728-73.728 73.728-73.728-32.768-73.728-73.728c1.024-40.96 33.792-73.728 73.728-73.728z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol